var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portfolio-posts-section__posts"},_vm._l((_setup.preparedPosts),function(post){return _c(_setup.PublicPortfolioPostsListSectionWarRoomPostPreview,{key:post.slug,staticClass:"portfolio-posts-section__posts__preview",attrs:{"post":post,"data-post-slug":post.slug}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }